import type { QuotaResult } from './types.ts';

const formatProviderName = (provider: string): string => {
  switch (provider) {
    case 'codex':
      return 'ChatGPT Codex';
    case 'antigravity':
      return 'Google Antigravity';
    case 'zai':
      return 'z.ai';
    default:
      return provider;
  }
};

const statusLabel = (result: QuotaResult): string => {
  if (result.ok) {
    return 'OK';
  }

  if (result.configured) {
    return 'WARN';
  }

  return 'MISSING';
};

export const toMarkdown = (results: QuotaResult[]): string => {
  const lines: string[] = ['# Provider Quotas', ''];

  for (const result of results) {
    const label = statusLabel(result);
    const providerName = formatProviderName(result.provider);

    lines.push(`## [${label}] ${providerName}`);
    lines.push('');
    lines.push(`**Status:** ${result.summary}`);
    lines.push('');

    if (result.data) {
      lines.push('<details>');
      lines.push('<summary>Raw Data</summary>');
      lines.push('');
      lines.push('```json');
      lines.push(JSON.stringify(result.data, null, 2));
      lines.push('```');
      lines.push('');
      lines.push('</details>');
    }

    if (result.error) {
      lines.push('');
      lines.push(`> **Error:** ${result.error}`);
    }

    lines.push('');
  }

  return lines.join('\n');
};

export const toCompactSummary = (results: QuotaResult[]): string => {
  return results
    .map((result) => {
      const label = statusLabel(result);
      return `[${label}] ${formatProviderName(result.provider)}: ${result.summary}`;
    })
    .join('\n');
};
